export enum S1LogQueryType {
    NONE = 0,
    REPOSITORY = 1,
    AUTHORIZATION = 2,
    TESTING = 3,
    DESIGNER = 4
}